export enum ChatStatusE {
  QUEUE = 'queue',
  ATTENDANCE = 'attendance',
  FINISHED = 'finished',
  STARTFLOW = 'start_flow',
  ENDFLOW = 'end_flow',
  TRANSFER = 'transfer',
  ABANDONED = 'abandoned',
  INTERNAL = 'internal',
  ARCHIVED = 'archived',
  NEW = 'new',
  API = 'api',
  DELAYED = 'delayed',
  WORKFLOW = 'workflow',
  WAITING = 'waiting',
  AI_ASSISTED = 'ai_assisted',
}
